import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getStudents } from '../utils/studentsService';
import './MobileChatPicker.css';

// Bottom-sheet student picker for the mobile nav's Chat tab when the
// teacher isn't already on a student's profile — tapping a name lands on
// that student's profile with the chat opened (via the ?chat=1 param
// StudentProfile.js watches for).
export default function MobileChatPicker({ onClose }) {
  const navigate = useNavigate();
  const [students, setStudents] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    let cancelled = false;
    getStudents()
      .then((map) => { if (!cancelled) setStudents(Object.values(map)); })
      .catch(() => { if (!cancelled) setStudents([]); });
    return () => { cancelled = true; };
  }, []);

  const filtered = (students || []).filter((s) =>
    (s.name || '').toLowerCase().includes(search.toLowerCase())
  );

  const pick = (slug) => {
    onClose();
    navigate(`/students/${slug}?chat=1`);
  };

  return (
    <div className="mobile-chat-picker-overlay" onClick={onClose}>
      <div className="mobile-chat-picker-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="mobile-chat-picker-header">
          <h3>Chat with a student</h3>
          <button type="button" className="mobile-chat-picker-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <input
          type="text"
          className="mobile-chat-picker-search"
          placeholder="Search students"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="mobile-chat-picker-list">
          {students === null && <div className="mobile-chat-picker-status">Loading…</div>}
          {students !== null && filtered.length === 0 && (
            <div className="mobile-chat-picker-status">No students found</div>
          )}
          {filtered.map((s) => (
            <button
              key={s.slug}
              type="button"
              className="mobile-chat-picker-item"
              onClick={() => pick(s.slug)}
            >
              {s.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
